import { SvgConsumer } from '@components/icons/svgConsumer';
import { Button } from '@components/ui/button';
import { AppTooltip } from '@components/ui/tooltip/tooltip';
import { formatDate } from '@utils/i18n';
import { RelatedSchedulesDialogSuggestedProps } from './types';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useRescheduler } from '@contexts/rescheduler';
import { getDate, getMonth, getYear, set } from 'date-fns';
import { toLocalWallClock, toTenantDate } from '@utils/timeZone';

export const RelatedSchedulesDialogSuggested = ({
  data,
  scheduleType,
}: RelatedSchedulesDialogSuggestedProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'relatedSchedules' });
  const { setValue } = useFormContext<{
    date?: Date;
    time?: Date;
    startsAt?: string;
    endsAt?: string;
  }>();

  const {
    schedule: { startsAt },
    removeSavedSchedule,
  } = useRescheduler();

  const suggestedDate = toTenantDate(startsAt);

  const withSuggestedDay = (isoDate: string) =>
    set(toTenantDate(isoDate), {
      year: getYear(suggestedDate),
      month: getMonth(suggestedDate),
      date: getDate(suggestedDate),
    });

  return (
    <div className="flex items-center gap-1 text-xs text-neutral-500">
      <span>
        <span>{t('suggested')}</span>
        <strong className="font-semibold">{formatDate(suggestedDate)}</strong>
      </span>
      <AppTooltip side="top" context={<p>{t('tooltip.suggested')}</p>}>
        <Button
          onClick={() => {
            removeSavedSchedule(data);
            if (scheduleType !== 'internal') {
              setValue('date', toLocalWallClock(withSuggestedDay(data.startsAt)));
              setValue('time', toLocalWallClock(toTenantDate(data.startsAt)));
            } else {
              setValue('startsAt', withSuggestedDay(data.startsAt).toISOString());
              setValue('endsAt', withSuggestedDay(data.endsAt).toISOString());
            }
          }}
          variant="ghost"
          className="h-fit p-1 text-m hover:bg-transparent hover:text-primary-500">
          <SvgConsumer id="add" />
        </Button>
      </AppTooltip>
    </div>
  );
};
